<!--
 * @Author: your name
 * @Date: 2020-12-30 22:16:20
 * @LastEditTime: 2021-01-08 14:27:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \beone\src\components\home\index.vue
-->
<template>
    <div>
        <div class="btns">
            <div v-for="(item,index) in categoryList" :key="'info1-'+index">
                <div v-if="item.name==='我要咨询'" @click="goAppeal('/appealDo', item)" class="btn">
                    <img style="margin-bottom: 15px" src="@/assets/b_1.png" alt="">
                    {{ item.name }}
                </div>
            </div>
            <div @click="visible2=true" class="btn">
                <img style="margin-bottom: 15px" src="@/assets/b_2.png" alt="">
                表扬和建议
            </div>
            <!--      <div @click="repair" class="btn">-->
            <!--        <img style="margin-bottom: 15px" src="@/assets/b_3.png" alt="">-->
            <!--        我要报修-->
            <!--      </div>-->
            <!--      <div @click="alertMessage('正在开发，敬请期待!')" class="btn">-->
            <!--        <img style="margin-bottom: 15px" src="@/assets/b_6.png" alt="">-->
            <!--        失物招领-->
            <!--      </div>-->
            <div @click="visible=true" class="btn">
                <img style="margin-bottom: 15px" src="@/assets/b_6.png" alt="">
                失物招领
            </div>

            <div v-for="(item,index) in categoryList" :key="'info3-'+index">
                <div v-if="item.name==='我要投诉'" @click="goAppeal('/appealDo', item)" class="btn">
                    <img style="margin-bottom: 15px" src="@/assets/b_4.png" alt="">
                    {{ item.name }}
                </div>
            </div>

            <div v-for="(item,index) in categoryList" :key="'info2-'+index">
                <div v-if="item.name==='领导信箱'" @click="goAppeal('/appealDo', item)" class="btn">
                    <img style="margin-bottom: 15px" src="@/assets/b_5.png" alt="">
                    {{ item.name }}
                </div>
            </div>
            <!--      <div @click="swzl" class="btn">-->
            <!--        <img style="margin-bottom: 15px" src="@/assets/b_6.png" alt="">-->
            <!--        失物招领-->
            <!--      </div>-->
        </div>
        <div style="padding: 40px 0 20px 0;">
            <div style="width: 1200px; margin: 0 auto;display: flex;align-items: flex-start;justify-content: space-between">
                <div class="bodyTopLeft">
                    <div class="bodyTopLeftTitle">通知公告</div>
                    <div class="bodyTopLeftTop" v-if="noticeList.length>0">
                        <div
                                style="font-size: 16px;line-height: 24px;overflow:hidden; text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:2; ">
                            {{ noticeList[0].name }}
                        </div>
                        <div v-html="noticeList[0].content"
                             style="color: #999999;height: 510px;overflow-y:scroll;font-size: 14px;line-height: 24px;"></div>
                        <router-link style="position: absolute;right: 0;bottom: 30px" to="message">
                            <img src="@/assets/more.png" alt="">
                        </router-link>
                    </div>
                    <div class="bodyTopLeftTop" v-else style="color: #b1b1b1;text-align: center;font-size: 20px">暂无
                    </div>
                    <!--          <div class="bodyTopLeftBottom" v-if="noticeList.length>1">-->
                    <!--            <div-->
                    <!--                style="font-size: 16px;line-height: 28px;overflow:hidden; text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:2; ">-->
                    <!--              {{ noticeList[1].name }}-->
                    <!--            </div>-->
                    <!--            <div v-html="noticeList[1].content"-->
                    <!--                 style="color: #999999;height: 170px;overflow-y:scroll;font-size: 14px;line-height: 24px;"></div>-->
                    <!--            <router-link style="position: absolute;right: 0;bottom: 30px" to="message">-->
                    <!--              <img src="@/assets/more.png" alt="">-->
                    <!--            </router-link>-->
                    <!--          </div>-->
                    <!--          <div class="bodyTopLeftTop" v-else style="color: #b1b1b1;text-align: center;font-size: 20px">暂无</div>-->
                </div>
                <div class="bodyTopRight">
                    <div class="center_top">
                        <div class="home_header">
                            <div class="home_header_left">
                                <img src="@/assets/tou.png" style="width:19px;height: 19px" alt="">
                                <span style="margin-left:10px;color: #333333; font-size: 18px;">阳光校务信息服务平台</span>
                            </div>
                            <router-link style="color: #ffb800;margin-right: 10px;" to="/reply">MORE+</router-link>
                        </div>
                        <div style="width: 100%;margin-top: 16px;">
                            <div class="card">
                                <div class="cardTitle" style="width: 14%">流水号</div>
                                <div class="cardTitle" style="width: 32%">标题</div>
                                <div class="cardTitle" style="width: 14%">日期</div>
                                <div class="cardTitle" style="width: 28%">受理单位</div>
                                <div class="cardTitle" style="width: 12%">状态</div>
                            </div>
                            <vue-seamless :class-option="classOption" style="height: 425px; overflow: hidden"
                                          :data="appealList">
                                <div v-for="(item, index) in appealList" :key="index" class="cardItems">
                                    <div style="width: 14%">{{ item.code }}</div>
                                    <div style="width:  32%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                        <router-link
                                                style="width: 100%; text-align: left"
                                                :to="{path: '/replyInfo',query: {record: encodeURIComponent(JSON.stringify(item))}}">
                                            {{ item.name }}
                                        </router-link>
                                    </div>
                                    <div style="width:14%">{{ item.gmtCreate.split(' ')[0] }}</div>
                                    <div style="width: 28%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                        {{ item.orgName }}
                                    </div>
                                    <div style="width:12%;">
                                        {{
                                        item.status === 0 ? '未受理' : item.status === 1 ? "已受理" : item.status === 2 ? "已完成" : item.status === 3 ? "已转交" : item.status === 4 ? "不受理" : ""
                                        }}
                                    </div>
                                </div>
                            </vue-seamless>
                        </div>
                    </div>
                    <div class="center_bottom">
                        <div class="center_right_row" style="margin-bottom: 20px;">
                            <div class="center_right_row_left">
                                <img src="@/assets/icon01.png" style="width:70px" alt="">
                                <div style="margin-left: 10px">
                                    <div style="color:rgb(64,112,255);font-size: 25px;">{{
                                        viewsDetails.appealCount
                                        }}
                                    </div>
                                    <div>累计收件</div>
                                </div>
                            </div>
                            <div class="center_right_row_right">
                                <img src="@/assets/icon02.png" style="width:70px" alt="">
                                <div style="margin-left: 10px">
                                    <div style="color:rgb(105,102,253);font-size: 25px;">{{
                                        viewsDetails.processed
                                        }}
                                    </div>
                                    <div>已处理收件</div>
                                </div>
                            </div>
                            <div class="center_right_row_left">
                                <img src="@/assets/icon03.png" style="width:70px" alt="">
                                <div style="margin-left: 10px">
                                    <div style="color:rgb(254,91,90);font-size: 25px;">{{
                                        viewsDetails.untreated
                                        }}
                                    </div>
                                    <div>未处理收件</div>
                                </div>
                            </div>
                            <div class="center_right_row_right">
                                <img src="@/assets/icon04.png" style="width:70px" alt="">
                                <div style="margin-left: 10px">
                                    <div style="color:rgb(202,99,228);font-size: 25px;">{{ viewsDetails.zjCount }}</div>
                                    <div>转交中</div>
                                </div>
                            </div>
                        </div>
                        <div class="center_right_row" style="justify-content:flex-start">
                            <div class="center_right_row_left">
                                <img src="@/assets/icon05.png" style="width:70px" alt="">
                                <div style="margin-left: 10px">
                                    <div style="color:rgb(65,204,139);font-size: 25px;">{{ viewsDetails.pvCount }}</div>
                                    <div>pv总量</div>
                                </div>
                            </div>
                            <div class="center_right_row_right">
                                <img src="@/assets/icon06.png" style="width:70px" alt="">
                                <div style="margin-left: 10px">
                                    <div style="color:rgb(14,126,183);font-size: 25px;">{{
                                        viewsDetails.accessCount
                                        }}
                                    </div>
                                    <div>访客数总量</div>
                                </div>
                            </div>
                            <div class="center_right_row_left">
                                <img src="@/assets/icon07.png" style="width:70px" alt="">
                                <div style="margin-left: 10px">
                                    <div style="color:rgb(255,128,64);font-size: 25px;">{{
                                        viewsDetails.nowCount
                                        }}
                                    </div>
                                    <div>今日访客数</div>
                                </div>
                            </div>
                        </div>
                        <!--            <div class="center_right_row"></div>-->
                        <!--          <img src="@/assets/img1.png" style="width: 360px;margin-bottom: 15px;cursor: pointer" alt="">-->
                        <!--          <img src="@/assets/img2.png" style="width: 360px;margin-bottom: 15px;cursor: pointer" alt="">-->
                        <!--          <img src="@/assets/img3.png" style="width: 360px;margin-bottom: 15px;cursor: pointer" alt="">-->
                    </div>
                </div>
            </div>
        </div>

        <!--    <div style="padding: 40px 0 20px 0;">-->
        <!--      <div style="width: 1200px; margin: 0 auto;display: flex;align-items: flex-start;justify-content: space-between">-->
        <!--        <div class="swzl">-->
        <!--          <div class="swzlItems">-->
        <!--            <div class="swzlItem" :key="index" v-for="(item,index) in lostList">-->
        <!--              <div class="swzlItemTitle" :style="index%2===0?'':'background-color:#ff8140;'">-->
        <!--                {{ item.status === 1 ? "寻找中" : "已找到" }}-->
        <!--              </div>-->
        <!--              <div class="swzlItemBody">-->
        <!--                <router-link-->
        <!--                    :to="{ path: '/lostAndFound/info',query: {record: encodeURIComponent(JSON.stringify(item))}}">-->
        <!--                  {{ item.name }}-->
        <!--                </router-link>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div @click="go('/lostAndFound')" class="swzlTitle">-->
        <!--            <span style="color: #fff">失物招领</span>-->
        <!--            <span style="margin-left: 100px;color: #fff">MORE</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="cjwt">-->
        <!--          <div class="cjwtLeft">-->
        <!--            <div class="cjwtTitle">学生/家长</div>-->
        <!--            <div class="cjwtItems">-->
        <!--              <div class="cjwtItem" :key="index" v-for="(item,index) in problemList.student">-->
        <!--                <router-link-->
        <!--                    :to="{ path: '/problem/info',query: {record: encodeURIComponent(JSON.stringify(item))}}">-->
        <!--                  {{ item.name }}-->
        <!--                </router-link>-->
        <!--              </div>-->
        <!--            </div>-->

        <!--            <div class="cjwtMore">-->
        <!--              <router-link style="color: #6966fd;" to="/problem">MORE</router-link>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="cjwtCenter">-->
        <!--            <div class="cjwtTitle">教师</div>-->
        <!--            <div class="cjwtItems">-->
        <!--              <div class="cjwtItem" :key="index" v-for="(item,index) in problemList.teacher">-->
        <!--                <router-link-->
        <!--                    :to="{ path: '/problem/info',query: {record: encodeURIComponent(JSON.stringify(item))}}">-->
        <!--                  {{ item.name }}-->
        <!--                </router-link>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="cjwtMore">-->
        <!--              <router-link style="color: #6966fd;" to="/problem">MORE</router-link>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="cjwtRight">-->
        <!--            常见问题-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--    </div>-->

        <!--    <div class="bottom" style="width: 1200px; margin: 0 auto; padding: 30px 0">-->
        <!--      <div class="bottom_left">-->
        <!--        <div class="home_header">-->
        <!--          <div class="home_header_left">-->
        <!--            <img src="@/assets/tou.png" style="width:19px;height: 19px" alt="">-->
        <!--            <span style="margin-left:10px;color: #333333; font-size: 18px;">我要表扬</span>-->
        <!--          </div>-->
        <!--          <router-link style="color: #ffb800;margin-right: 10px;" :to="{path:'/reply',query:{classify:4}}">MORE+-->
        <!--          </router-link>-->
        <!--        </div>-->
        <!--        <div class="list">-->
        <!--          <div class="list_items">-->
        <!--            <div class="list_item" v-for="(item, index) in praiseList" :key="index">-->
        <!--              <router-link-->
        <!--                  :to="{ path: '/replyInfo',query: {record: encodeURIComponent(JSON.stringify(item))}}">-->
        <!--                {{ item.name }}-->
        <!--              </router-link>-->
        <!--              <span>{{ item.gmtCreate }}</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--      <div class="bottom_right">-->
        <!--        <div class="home_header">-->
        <!--          <div class="home_header_left">-->
        <!--            <img src="@/assets/tou.png" style="width:19px;height: 19px" alt="">-->
        <!--            <span style="margin-left:10px;color: #333333; font-size: 18px;">我要建议</span>-->
        <!--          </div>-->
        <!--          <router-link style="color: #ffb800;margin-right: 10px;" :to="{path:'/reply',query:{classify:2}}">MORE+-->
        <!--          </router-link>-->
        <!--        </div>-->
        <!--        <div class="list">-->
        <!--          <div class="list_items">-->
        <!--            <div class="list_item" v-for="(item, index) in suggestList" :key="index">-->
        <!--              <router-link-->
        <!--                  :to="{ path: '/replyInfo',query: {record: encodeURIComponent(JSON.stringify(item))}}">-->
        <!--                {{ item.name }}-->
        <!--              </router-link>-->
        <!--              <span>{{ item.gmtCreate }}</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--    </div>-->
        <a-modal
                title="失物招领"
                :visible="visible"
                :footer="false"
                @cancel="visible = false"
        >
            <div class="lostItems">
                <div @click="goLostAndFound('/lostAndFound',1)" class="lostItem">
                    <a-icon type="caret-right" theme="filled"/>
                    失物信息查询
                </div>
                <div
                        style="background-color: #e8b65f"
                        @click="goLostAndFound('/lostAndFound',2)"
                        class="lostItem"
                >
                    <a-icon type="caret-right" theme="filled"/>
                    招领信息查询
                </div>
                <div
                        style="background-color: #c87446"
                        @click="goAppeal('/lostAndFound/lost')"
                        class="lostItem"
                >
                    <a-icon type="caret-right" theme="filled"/>
                    失物信息发布
                </div>
                <div
                        style="background-color: #7aae70"
                        @click="showLostMessage"
                        class="lostItem"
                >
                    <a-icon type="caret-right" theme="filled"/>
                    招领信息发布
                </div>
            </div>
        </a-modal>
        <a-modal
                title="表扬和建议"
                :visible="visible2"
                :footer="false"
                @cancel="visible2 = false"
        >
            <div class="lostItems">
                <div v-for="(item,index) in categoryList" :key="'info1-'+index" v-show="item.name==='我要表扬'"
                     style="background-color:rgb(253,132,105)" @click="goAppeal('/appealDo', item)" class="lostItem">
                    <a-icon type="caret-right" theme="filled"/>
                    {{ item.name }}
                </div>
                <div v-for="(item,index) in categoryList" :key="'info2-'+index" v-show="item.name==='我要建议'"
                     @click="goAppeal('/appealDo', item)" class="lostItem">
                    <a-icon type="caret-right" theme="filled"/>
                    {{ item.name }}
                </div>
            </div>
        </a-modal>

        <a-modal
                title="我要报修"
                :visible="visible3"
                :footer="false"
                destroyOnClose
                @cancel="visible3 = false"
        >
            <div id="qrCodeUrl" class="qrcode" ref="qrCodeUrl"></div>
        </a-modal>
    </div>
</template>

<script>
// import {getNongli} from "@/utils/index";
import {getAction, postAction} from "@/api/manage";
import vueSeamless from "vue-seamless-scroll";


export default {
    data() {
        return {
            date: "",
            type: 1,
            noticeList: [],
            lostList: [],
            appealList: [],
            suggestList: [],
            praiseList: [],
            categoryList: [],
            problemList: [],
            bannerList: [],
            visible: false,
            visible2: false,
            visible3: false,
            url: window._CONFIG['url'] + '/common/file/downLoadByJava?path=',
            viewsDetails: {},
        };
    },
    components: {
        vueSeamless,
    },
    computed: {
        classOption() {
            return {
                // direction: 0,
                step: 0.2,
            };
        },
    },
    created() {
        this.getViewsDetails();
        this.getCategoryList();
        this.getNoticeList();
        // this.getLostList();
        this.getAppealList();
        // this.getPraiseList();
        // this.getSuggestList();
        // this.getProblemList();
    },
    methods: {
        repair() {
            this.visible3 = true
            this.$nextTick(() => {
                window.WwLogin({
                    "id": "qrCodeUrl",
                    "appid": window._CONFIG["appid"],
                    "agentid": window._CONFIG["agentid"],
                    "redirect_uri": window._CONFIG["redirect_uri"],
                    "state": "STATE",
                    "href": "",
                });
            })
        },
        go(url) {
            this.$router.push(url)
        },
        leaderEmail() {
            this.visible2 = true
        },
        goLostAndFound(url, type) {
            this.$router.push({
                path: url,
                query: {
                    type: type
                }
            })
        },
        goEmail(url, type) {
            this.$router.push({
                path: url,
                query: {
                    type: type
                }
            })
        },
        getViewsDetails() {
            getAction("/user/appeal/getViewsDetails").then((data) => {
                this.viewsDetails = data.data;
            });
        },
        showLostMessage() {
            this.$notification["info"]({
                message: "信息",
                description:
                    "如果您拾到了他人物品，请将物品交给阳光校务服务值班学生或者各部门阳光校务服务中心信息员（本具体见本网站的“联系我们”）。他们会及时在网上发布信息找寻失主，向拾金不昧、助人为乐的您致敬！",
                duration: 5,
            });
        },
        swzl() {
            this.visible = true;
        },
        alertMessage(content) {
            this.$info({
                title: '提示',
                content: content,
                onOk() {
                }
            })
        },
        goAppeal(url, item) {
            if (item) {
                if (item.name === '领导信箱') {
                    this.$router.push({
                        path: '/leaderDo',
                    });
                } else {
                    this.$router.push({
                        path: url,
                        query: {
                            record: encodeURIComponent(JSON.stringify(item)),
                        },
                    });
                }
            } else {
                this.$router.push(url)
            }
        },
        getCategoryList() {
            postAction("/user/appeal/category/categoryList").then((data) => {
                this.categoryList = data.data.list
                // data.data.list.forEach((item, index) => {
                //   if (item.name !== '我要表扬' || item.name !== '我要建议') {
                //     this.categoryList.push(item)
                //   }
                // })
            });
        },

        getNoticeList() {
            postAction("/sys/notice/list", {
                pageNo: 1,
                pageSize: 2,
            }).then((data) => {
                this.noticeList = data.data.list;
            });
        },
        // getLostList() {
        //   postAction("/user/lost/lostList", {
        //     pageNum: 1,
        //     pageSize: 8,
        //   }).then((data) => {
        //     this.lostList = data.data.list;
        //   });
        // },
        getAppealList() {
            postAction("/user/appeal/appeal/listByClassify", {
                pageNum: 1,
                pageSize: 20,
            }).then((data) => {
                this.appealList = data.data.list;
            });
        },
        // getSuggestList() {
        //   postAction("/user/appeal/appeal/listByClassify", {
        //     pageNum: 1,
        //     pageSize: 6,
        //     classify: 2, //建议
        //   }).then((data) => {
        //     this.suggestList = data.data.list;
        //   });
        // },
        // getPraiseList() {
        //   postAction("/user/appeal/appeal/listByClassify", {
        //     pageNum: 1,
        //     pageSize: 6,
        //     classify: 4, //表扬
        //   }).then((data) => {
        //     this.praiseList = data.data.list;
        //   });
        // },
        // getProblemList() {
        //   postAction("/user/appeal/appeal/problem", {
        //     pageNum: 1,
        //     pageSize: 6,
        //   }).then((data) => {
        //     this.problemList = data.data;
        //   });
        // },

    },
};
</script>
<style>


.dotsClass {
    position: absolute !important;
    bottom: 0 !important;
    left: 0 !important;
    text-align: right !important;
    background-color: rgba(0, 0, 0, 0.5);
    height: 40px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end;
    padding-right: 10px !important;
}

.dotsClass li button {
    width: 10px !important;
    height: 10px !important;
    border-radius: 50% !important;
    margin-left: 10px !important;
    opacity: 1 !important;
}

.dotsClass .slick-active button {
    background-color: rgb(188, 20, 13) !important;
}

.dotsClass li button:hover {
    background-color: rgba(188, 20, 13, 0.3) !important;
}

</style>
<style scoped lang="scss">
.btns {
  width: 100%;
  height: 529px;;
  background: url(~@/assets/banner1.png);
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn {
  width: 177px;
  height: 202px;
  margin-right: 15px;
  background: url(~@/assets/banner_bj_hover.png);
  opacity: 0.8;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  color: #960000;
}

.btn:hover {
  cursor: pointer;
  transition: 0.3s;
  opacity: 1;
}

.top {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  /*height: 390px;*/

}

.center {

}

.top_left, .top_center, .top_right {
  width: 380px;
  height: 100%;
  /*background-color: #0F62AA;*/
}

/*.top_left {*/
/*  width: 420px;*/
/*}*/

.list {
  display: flex;
  align-items: center;
  /*height: 95px;*/
  margin-top: 20px;
  justify-content: space-between;
}

.top_left_list_left {
  width: 45px;
  color: #fff;
  height: 100%;
  font-size: 16px;
  writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
  writing-mode: tb-lr;
  background: #1b84a1;
  display: flex;
  align-items: center;
  letter-spacing: 3px;
  justify-content: center;
  word-wrap: break-word;
}

.list_items {
  width: 100%;
  display: flex;
  height: 100%;
  font-size: 13px;
  color: #666666;
  justify-content: flex-start;
  flex-direction: column;
}

.list_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
}

.home_header {
  width: 100%;
  display: flex;
  margin-bottom: 12px;
  align-items: center;
  justify-content: space-between;
  height: 20px;
}

.home_header_left {
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.top_right_title {
  line-height: 40px;
  text-align: center;
  color: #1b84a1;
  font-size: 16px;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 10px;
}

.top_right_items {
  line-height: 30px;
}

.center_top {
  width: 100%
}

.center_bottom {
  width: 100%;
  margin-top: 10px;
  border-radius: 20px;
  padding: 20px 20px;
  border: solid 1px #ffaa5f;
}

.center_right_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 15px;
  /*margin-bottom: 20px;*/
}

.center_right_row_left, .center_right_row_right {
  display: flex;
  width: 25%;
  /*margin-left: 10px;*/
  align-items: flex-end;
}

.bottom {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.bottom_left, .bottom_right {
  width: 48%;
  min-height: 250px;
}

a {
  color: #333;
  text-decoration: none;
}

li {
  list-style: none;
}

a:hover {
  color: #cd0200;
  text-decoration: underline;
}

.question {
  float: left;
  width: 365px;
  margin-right: 20px;
}

.quTitle {
  width: 100%;
  height: 44px;
  line-height: 44px;
  border-top: 7px solid #2b78c8;
  background: #e6e6e6;
}

.quTitle span {
  float: left;
  padding-left: 10px;
  font-size: 18px;
  font-weight: normal;
}

.quTitle a {
  float: right;
  padding-right: 8px;
  font-weight: normal;
}

.quList {
  float: left;
  margin-top: 10px;
}

.quList {
  border-bottom: 1px solid #ddd;
}

.quList td {
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
}

.studentPic {
  float: left;
  width: 47px;
  height: 133px;
  padding-top: 8px;
}

.studentCont {
  float: right;
  width: 280px;
}

.studentCont h4 {
  width: 100%;
  height: 35px;
  line-height: 35px;
  border-bottom: 1px solid #f3cf67;
  font-weight: normal;
}

.studentCont h4 span {
  font-size: 14px;
}

.studentCont h4 a {
  float: right;
  font-size: 12px;
  padding-right: 5px;
}

.studentList li {
  float: left;
  width: 260px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  padding-left: 15px;
  background: url(~@/assets/arrow.jpg) no-repeat left center;
}

.lostList {
  float: left;
  width: 365px;
  height: 275px;
  border: 1px solid #ddd;
  margin-top: 10px;
  overflow: hidden;
}

.lostList li {
  float: left;
  height: 30px;
  line-height: 30px;
  width: 355px;
  padding: 5px 10px;
  font-size: 14px;
}

.lostList li a {
  float: left;
  width: 264px;
  height: 30px;
  line-height: 30px;
  background: url(~@/assets/point.jpg) no-repeat left center;
  padding-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.look {
  color: #666666;
}

.find {
  color: #ffb800;
}

.imgs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.img {
  width: 224px;
  margin-bottom: 10px;
  cursor: pointer;
}

.img:hover {
  opacity: 0.8;
  transition: 0.5s;
}

.card {
  display: flex;
  align-items: center;
  height: 38px;
  text-align: center;
  color: #fff;
  background-color: #ffaa5f;
}

.cardTitle {
  text-align: center;
}

.cardItems {
  display: flex;
  align-items: center;
  text-align: center;
  height: 35px;
}

.lostItems {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.lostItem {
  width: 49%;
  margin-bottom: 20px;
  cursor: pointer;
  height: 55px;
  line-height: 55px;
  text-align: center;
  background-color: #6395de;
  color: #fff;
  font-size: large;
}

.bodyTopLeft {
  background: url(~@/assets/tz1.png) no-repeat center;
  width: 280px;
  height: 715px;
  margin-right: 44px;
}

.bodyTopLeftTitle {
  font-family: SourceHanSansCN-Normal;
  font-size: 22px;
  line-height: 46px;
  text-align: center;
  color: #ffffff;
}

.bodyTopLeftTop, .bodyTopLeftBottom {
  height: 660px;
  padding: 20px 15px;
  position: relative;

  ::-webkit-scrollbar {
    width: 3px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #f6f6f6;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb {
    background: #cdcdcd;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #747474;
  }

  ::-webkit-scrollbar-corner {
    background: #f6f6f6;
  }

}

/*p {*/
/*  margin-bottom: 0;*/
/*}*/

.bodyTopRight {
  width: 876px;
}

.swzl {
  width: 475px;
}

.swzlItems {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.swzlItem {
  width: 33%;
  margin-bottom: 15px;
}

.swzlItemTitle {
  height: 30px;
  background-color: #ffb270;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.swzlItemBody {
  height: 80px;
  padding: 20px;
  text-align: center;
  background-color: #fcfcfc;
  line-height: 24px;
  color: #666666;
  border: solid 1px #eeeeee;
}

.cjwt {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.swzlTitle {
  width: 100%;
  height: 54px;
  background-image: linear-gradient(-90deg, #ffb471 0%, #ff9a59 57%, #ff8040 100%);
  text-align: center;
  line-height: 54px;
  cursor: pointer;
}

.cjwtLeft, .cjwtCenter, .cjwtRight {
  background-color: #f4f4fe;
  height: 303px;

}

.cjwtLeft, .cjwtCenter {
  width: 280px;
  border-radius: 10px;
  padding: 20px 20px;
  margin-right: 25px;
  display: flex;
  /*align-items: center;*/
  flex-direction: column;
  justify-content: space-around;
}

.cjwtTitle {
  font-size: 20px;
  height: 24px;
  color: #4c4545;
  text-align: center;
  font-family: SourceHanSansCN-Normal;
  margin-bottom: 10px;
}

.cjwtRight {
  font-size: 24px;
  width: 77px;
  word-wrap: break-word;
  color: #6966fd;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 25px;
}

.cjwtItems {
  height: 209px;
  font-size: 14px;
  color: #666666;
  /*display: flex;*/
  /*align-items: flex-start;*/
  /*justify-content: flex-start;*/
  /*flex-direction: column;*/
}

.cjwtItem {
  line-height: 32px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cjwtMore {
  /*margin-top:10px;*/
  height: 30px;
  text-align: center;
}

.qrcode {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
